import type { FunctionComponent, ReactNode } from 'react';
import { useCallback } from 'react';
import classNames from 'classnames';
import { Switch } from '@george-labs.com/design-system';

import styles from './DevToolsToggle.module.scss';

const SWITCH_ANIMATION_DURATION_MS = 150;

interface DevToolsToggleProps {
    className?: string;
    active: boolean;
    label: ReactNode;
    onToggle: (isActive: boolean) => void;
}

export const DevToolsToggle: FunctionComponent<DevToolsToggleProps> = ({
    className: classNameProp,
    active,
    label,
    onToggle,
}) => {
    const reportToggle = useCallback(
        (isActive: boolean) => {
            setTimeout(() => onToggle(isActive), SWITCH_ANIMATION_DURATION_MS);
        },
        [onToggle],
    );

    const className = classNames('px-2', classNameProp);

    return (
        <section className={className}>
            <label
                className={`d-flex align-items-center justify-content-between m-0 g-small ${styles.toggle}`}
            >
                {label}
                <Switch active={active} onToggle={reportToggle} />
            </label>
        </section>
    );
};
